import React, { useEffect, useState } from "react";
import { optionCtaHoverStyle, optionCtaStyle, primaryCtaHoverStyle, primaryCtaStyle, secondaryCtaHoverStyle, secondaryCtaStyle } from "../utils/CtaStyles";

export default function CtaHOC(Component) {
    return function(props) {

        const [ctaStyles, setCtaStyles] = useState({})
        useEffect(() => {
            let ctaStyleType = props?.ctaStyleType
            let ctaStyles = {
                cta : primaryCtaStyle,
                ctaHover : primaryCtaHoverStyle
            }
            if (ctaStyleType == "secondary") {
                ctaStyles.cta = secondaryCtaStyle
                ctaStyles.ctaHover = secondaryCtaHoverStyle
            }
            if (ctaStyleType == "default") {
                ctaStyles.cta = optionCtaStyle
                ctaStyles.ctaHover = optionCtaHoverStyle
            }
            setCtaStyles(ctaStyles)
        },[])
        return <Component {...props} ctaStyles={ctaStyles} />
    };
    
}